import authRoutes from '@domains/auth/routes'
import bankerPromoCodeRoutes from '@domains/banker-promo-code/routes'
import clientsRoutes from '@domains/clients/routes'
import completedOperationsRoutes from '@domains/completed-operations/routes'
import dashboardRoutes from '@domains/dashboard/routes'
import developersRoutes from '@domains/developers/routes'
import posOperationsRoutes from '@domains/pos-operations/routes'
import preOperationsRoutes from '@domains/pre-operations/routes'
import superAdminsRoutes from '@domains/super-admins/routes'
import targetTaxesRoutes from '@domains/target-taxes/routes'
import DesignSystem from '@shared/components/designSystem.vue'

import Main from '@/container/Main.vue'

export default [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/'
  },
  ...authRoutes,
  {
    path: '/',
    name: 'Main',
    redirect: 'dashboard',
    component: Main,
    meta: {
      requiresAuth: true
    },
    children: [
      ...dashboardRoutes,
      ...targetTaxesRoutes,
      ...preOperationsRoutes,
      ...posOperationsRoutes,
      ...completedOperationsRoutes,
      ...clientsRoutes,
      ...superAdminsRoutes,
      ...developersRoutes,
      ...bankerPromoCodeRoutes
    ]
  },
  {
    path: '/design-system',
    component: DesignSystem,
    name: 'DesignSystem',
    meta: { requiresAuth: true }
  }
]
